import * as ex from 'excalibur';
import { Allegiance, ControlType } from '../types/enums';
import { Grid } from '../core/grid';
import { Unit } from '../core/unit';
import { 
  Merk, 
  Imp, 
  Rogue, 
  Dog, 
  PlayerMerk, 
  PlayerImp, 
  PlayerRogue, 
  PlayerDog 
} from '../units';

// Factory for creating units
export class UnitFactory {
  static createUnit(
    type: string, 
    gridX: number, 
    gridY: number, 
    allegiance: Allegiance,
    initiative: number, 
    grid: Grid, 
    isPlayerControlled: boolean = false
  ): Unit {
    // Base options for all units
    const baseOptions = {
      gridX,
      gridY,
      allegiance,
      initiative,
      grid
    };

    let unit: Unit;

    // Create the appropriate unit type
    switch (type.toLowerCase()) {
      case 'merk':
        unit = isPlayerControlled
          ? new PlayerMerk(baseOptions)
          : new Merk(baseOptions);
        break;
      case 'imp':
        unit = isPlayerControlled
          ? new PlayerImp(baseOptions)
          : new Imp(baseOptions);
        break;
      case 'rogue':
        unit = isPlayerControlled
          ? new PlayerRogue(baseOptions)
          : new Rogue(baseOptions);
        break;
      case 'dog':
        unit = isPlayerControlled
          ? new PlayerDog(baseOptions)
          : new Dog(baseOptions);
        break;
      default:
        throw new Error(`Unknown unit type: ${type}`);
    }

    return unit;
  }
}